import React from 'react';

function DeleteAccountConfirmationModal(props) {
	return (
		<div className="container-modal">
			<div className="background-modal" onClick={() => props.hideModal()}></div>
			<div className="modal-content confirm-delete-account-modal">
				<h4 className="modal-bold-title center-modal-title">
					Êtes vous vraiment sûr de vouloir supprimer votre compte ? Vous ne
					pourrez plus y accéder et perdrez accès à toutes les données.
				</h4>
				<div className="delete-modal-rwo-btns">
					<button
						type="button"
						className="modal-confirm-btn light-bold red-delete-btn"
						onClick={() => props.hideModal()}
					>
						Annuler
					</button>
					<button
						type="button"
						className="modal-confirm-btn light-bold"
						onClick={() => props.confirmDelete()}
					>
						Confirmer
					</button>
				</div>
			</div>
		</div>
	);
}

export default DeleteAccountConfirmationModal;
